export default function trimAndFormatNumber(value) {
  const trimmed = value.trim().replaceAll(' ', '');
  return trimmed[0] === '0' ? trimmed.slice(1, trimmed.length) : trimmed;
}
